import { rei } from "@/services/api"

class lancamentoService {

    static storeLancamento (payload) {
        return rei.post('lancamento-store', payload)
          .then(res => res.data)
      }
    
    static excluirPagamentosAvulsos (payload) {
        return rei.post('excluir-pagamentos-avulsos', payload)
        .then(res => res.data)
      }
    
    static editarLancamentos (payload) {
        return rei.post('lancamento-editar', payload)
          .then(res => res.data)
    }

    static editarDespesa (payload) {
      return rei.post('lancamento-editar-despesa', payload)
      .then(res => res.data)
    }

    static getDespesas (caixaId) {
      return rei.get(`lancamento-despesas/${caixaId}`)
      .then(res => res.data)
    }
}

export default lancamentoService